module.exports = __webpack_public_path__ + "img/thingsBanner.80168f47.png";